<template>
     <v-card>
        <v-layout>
            <v-card-title class="headline">
                <strong class="headline deep-purple--text">Criar potencial</strong> 
            </v-card-title>
        </v-layout>
        <v-divider class="deep-purple"/>
        <v-layout row wrap class="mx-4 mt-3">        
            <v-flex xs12 md6>
                <SelectCreditors :multiple="false" @selectedCreditors="potential.creditor_id = $event" />
            </v-flex>
            <v-flex xs12 sm12>
                <v-checkbox  class="mx-1 mt-5" label="Ativo" v-model="potential.active" color="deep-purple"/>  
            </v-flex>                          
            <v-flex sm10 md4>
                <v-text-field class="mx-1" type="number" step="1" label="Mínimo de dias de atraso" box v-model="potential.min_days_of_delay"/>                
            </v-flex>  
            <v-flex sm10 md4>
                <v-text-field class="mx-1" type="number" step="1" label="Máximo de dias de atraso" box v-model="potential.max_days_of_delay" :disabled="is_null_max_days_of_delay"/>                
            </v-flex>
            <v-flex sm10 md4>
                <v-text-field class="mx-1" type="number" step="0.01" label="Potencial de ganho" hint="decimal (0,00)" box v-model="potential.fee"/>                
            </v-flex>
            <v-checkbox class="mx-1" v-model="is_null_max_days_of_delay" label="Sem máximo de dias de atraso" color="deep-purple"  @change="altera_max_days_of_delay"/>            
        </v-layout>
        <v-divider class="deep-purple"/>
        <v-card-actions class="py-2">
            <v-btn flat color="primary" @click="fechar_modal">Cancelar</v-btn>  
            <v-spacer></v-spacer>
            <v-btn color="deep-purple" dark @click="salvar" :disabled="esperar">Salvar</v-btn>     
        </v-card-actions>
    </v-card>    
</template>

<script>
import SelectCreditors from "@/components/creditor/SelectCreditors";
export default {
    components:{
        SelectCreditors
    },
    props:['esperar'],
    data(){
        return{
            potential:{
               min_days_of_delay:0,
               max_days_of_delay:0,
               fee:0.0,
               active:true,
               creditor_id:0
           },
           is_null_max_days_of_delay:false
        }
    },
    methods:{
        estado_inicial(){
            this.potential = {
               min_days_of_delay:0,
               max_days_of_delay:0,
               fee:0.0,
               active:true,
               creditor_id: this.potential.creditor_id
           }
           this.is_null_max_days_of_delay=false
        },
        fechar_modal(){
            this.$emit('fechar')
            this.estado_inicial()
        },
        salvar(){
            this.$emit('salvar', this.potential)
            this.estado_inicial()
        },
        altera_max_days_of_delay(){
            if (this.potential.max_days_of_delay === null) {
                this.potential.max_days_of_delay = 0
                this.is_null_max_days_of_delay = false
            } else {
                this.potential.max_days_of_delay = null
                this.is_null_max_days_of_delay = true
            }
        }
    }  
}
</script>